<template>
	<div>
		<div class="header">
		    <!-- 折叠按钮 -->
		    <div class="collapse-btn" @click="collapseChage">
		        <i v-if="!collapse" class="el-icon-s-fold"></i>
		        <i v-else class="el-icon-s-unfold"></i>
		    </div>
		    <div class="logo">工程机械管理后台</div>
		    <div class="header-right">
		        <div class="header-user-con">
					<!-- 分支机构信息 -->
					<div v-if="organinfoKind != 2" class="btn-addheader" @click="fzinfobtn">
						<el-tooltip content="分支机构信息">
							<i class="el-icon-postcard"></i>
						</el-tooltip>
					</div>
					<!-- 添加证书 -->
					<div class="btn-addheader" style="padding-right: 6px;">
						<el-tooltip content="批量添加证书">
							<router-link to="/addbatchcer" >
									<i class="el-icon-document-add"></i>
							</router-link>
						</el-tooltip>
					</div>
					               
					<!-- 全屏显示 -->
					<div class="btn-fullscreen" @click="handleFullScreen">
					    <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
					        <i class="el-icon-rank"></i>
					    </el-tooltip>
					</div>
					
		            <!-- 消息中心 -->
		            <div class="btn-bell" v-if="organinfoKind == 2">
						<div v-if="role != 3">
							<el-tooltip
							    effect="dark"
							    :content="totalNum?`有${totalNum}条待办项`:`未待办项`"
							    placement="bottom"
							>
							    <router-link to="/remandmessage" v-if="totalNum">
							        <i class="el-icon-bell"></i>
							    </router-link>
								<i v-else class="el-icon-bell"></i>
							</el-tooltip>
							
							<span class="btn-bell-badge" v-if="totalNum"></span>
						</div>
		               
		            </div>
					
		            <!-- 用户头像 -->
		            
		            <!-- 用户名下拉菜单 -->
		            <el-dropdown class="user-name" trigger="click" @command="handleCommand">
		                <span class="el-dropdown-link">
		                    {{username}}
		                    <i class="el-icon-caret-bottom"></i>
		                </span>
						<el-dropdown-menu slot="dropdown">
						    <el-dropdown-item divided command="loginpwdchange">修改密码</el-dropdown-item>
							<el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
						</el-dropdown-menu>
		            </el-dropdown>
					<div class="user-avator">
					    <img src="../assets/img/touxiang.png" />
					</div>
					
		        </div>
		    </div>
		</div>
		
		<!-- 查看 -->
		<el-dialog class="branch-dialog" title="分支机构信息" :visible.sync="fzinfoVisible" width="600px">
			<div class="fzinfo-list">
				<p><span>单位名称:</span> {{fzinfolist.name}}</p>
				<p><span>统一信用代码:</span> {{fzinfolist.unifiedCreditCode}}</p>
				<p><span>邮寄地址:</span> {{fzinfolist.shippingAddress}}</p>
				<p><span>联系人: </span> {{fzinfolist.liaisonerName}}</p>
				<p><span>电话:</span> {{fzinfolist.cellphoneNumber}}</p>
				<p><span>用户服务电话:</span> {{fzinfolist.userServicePhone}}</p>
			</div>
			<span class="fzinfo-btn">
				<el-button type="primary" @click="fzinfoedit()">编 辑</el-button>
			</span>
		    
		</el-dialog>
		
		<!-- 编辑 -->
		<el-dialog class="branch-dialog" title="编辑分支机构" :visible.sync="fzinfoeditVisible" width="600px">
		    <el-form ref="fzinfoeditform" :model="fzinfoeditform" :rules="fzinfoeditrules">
		        <el-form-item label="单位名称" prop="name">
		            <el-input v-model="fzinfoeditform.name"></el-input>
		        </el-form-item>
		        <el-form-item label="统一信用代码" prop="unifiedCreditCode">
		            <el-input v-model="fzinfoeditform.unifiedCreditCode"></el-input>
		        </el-form-item>
		    	<el-form-item label="邮寄地址" prop="shippingAddress">
		    	    <el-input v-model="fzinfoeditform.shippingAddress"></el-input>
		    	</el-form-item>
		    	<el-form-item label="联系人" prop="liaisonerName">
		    	    <el-input v-model="fzinfoeditform.liaisonerName"></el-input>
		    	</el-form-item>
		    	<el-form-item label="电话" prop="cellphoneNumber">
		    	    <el-input v-model="fzinfoeditform.cellphoneNumber"></el-input>
		    	</el-form-item>
		    	<el-form-item label="用户服务电话" prop="userServicePhone">
		    	    <el-input v-model="fzinfoeditform.userServicePhone"></el-input>
		    	</el-form-item>
		    	
		    </el-form>
		    
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="fzinfoeditVisible = false">取 消</el-button>
		        <el-button type="primary" @click="savefzinfoEdit('fzinfoeditform')">确 定</el-button>
		    </span>
		</el-dialog>
		
		<!-- 修改密码 -->
		<el-dialog class="branch-dialog" title="修改密码" :visible.sync="pwdchangeVisible" width="600px">
		    <el-form ref="pwdchangeform" :model="pwdchangeform" :rules="pwdchangerules">
		        <el-form-item label="旧密码" prop="oldPassWord">
		            <el-input type="passWord" v-model="pwdchangeform.oldPassWord"></el-input>
		        </el-form-item>
		        <el-form-item label="新密码" prop="newPassWord" class="change-password">
		            <el-input type="passWord" v-model="pwdchangeform.newPassWord"></el-input>
		        </el-form-item>
		    	<el-form-item label="确认新密码" prop="checknewPassWord" class="change-password">
		    	    <el-input type="passWord" v-model="pwdchangeform.checknewPassWord"></el-input>
		    	</el-form-item>
		    </el-form>
		    
		    <span slot="footer" class="dialog-footer">
		        <el-button @click="pwdchangeVisible = false">取 消</el-button>
		        <el-button type="primary" @click="savepwdchange('pwdchangeform')">修改并登录</el-button>
		    </span>
		</el-dialog>
		
		
	</div>
	
    
</template>
<script>
import bus from './bus';
import { listTaskRemindNum,getBranchData,updateBranchData,updatePassword } from '@/api/index';// 导入我们的api接口

export default {
    data() {
		var validPhone = (rule, value, callback) => {
					  // debugger
		       const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
		       if (!value) {
		         return callback(new Error('电话号码不能为空'))
		       }else if(!Number.isInteger(+value)) {
		           callback(new Error('请输入数字值'))
		       } else {
		           if (phoneReg.test(value)) {
		             callback()
		        } else {
		             callback(new Error('电话号码格式不正确'))
		           }
		         }
		};
		var validatePasschange1 = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请输入密码'));
			} else {
			  if (this.pwdchangeform.checknewPassWord !== '') {
				this.$refs.pwdchangeform.validateField('checknewPassWord');
			  }
			  callback();
			}
		};
		var validatePasschange2 = (rule, value, callback) => {
			if (value === '') {
			  callback(new Error('请再次输入密码'));
			} else if (value !== this.pwdchangeform.newPassWord) {
			  callback(new Error('两次输入密码不一致!'));
			} else {
			  callback();
			}
		  };      //输入密码和确认密码校验
        return {
            collapse: false,
            fullscreen: false,
            name: 'linxin',
            // totalNum: '',
			organinfoKind:'', //分支机构按钮显示隐藏
			role:'',  //总部角色
			fzinfoVisible:false,  //分支机构信息
			fzinfolist:{},
			fzinfoeditVisible:false,  //编辑
			fzinfoeditform:{
				
			},
			fzinfoeditrules:{
				name: [
					{ required: true, message: '请输入单位名称',  trigger: ['blur', 'change']  }
				],
				unifiedCreditCode: [
					{ required: true, message: '请输入统一信用代码', trigger: ['blur', 'change']  }
				],
				shippingAddress: [
					{ required: true, message: '请输入邮寄地址',  trigger: ['blur', 'change']  }
				],
				liaisonerName: [
					{ required: true, message: '请输入联系人',  trigger: ['blur', 'change']  }
				],
				cellphoneNumber: [
					{ required: true,  validator: validPhone, trigger: ['blur', 'change'] }
				],
				userServicePhone: [
					{ required: true, message: '请输入用户服务电话', trigger: ['blur', 'change']  }
				],
			},
			pwdchangeVisible:false,
			pwdchangeform:{
				oldPassWord:'',  //旧密码
				newPassWord:''  ,//新密码
				checknewPassWord:'',  //确认新密码
			},
			pwdchangerules:{
				oldPassWord:{required: true, message: '请输入旧密码', trigger: ['blur', 'change']},
				newPassWord: [
				  { validator: validatePasschange1, trigger: 'blur' }
				],
				checknewPassWord: [
				  { validator: validatePasschange2, trigger: 'blur' }
				],
			},
			
        };
    },
    computed: {
        username() {
            let username = localStorage.getItem('ms_username');
            return username ? username : this.name;
        },
		totalNum(){
			return  this.$store.state.totalNum;
		},
		
    },
    methods: {
		fzinfobtn(){
			getBranchData({},{}).then(res => {
						  // 获取数据成功后的其他操作
				this.fzinfolist = res.data;        
			});
			this.fzinfoVisible = true;
		},
		fzinfoedit(){
			this.fzinfoeditform = this.fzinfolist;
			this.fzinfoeditVisible = true;
			this.fzinfoVisible = false;
		},
		savefzinfoEdit(formName){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  updateBranchData(this.fzinfoeditform).then(res => {
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.fzinfoeditVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
		},
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == 'loginout') {
                localStorage.removeItem('Authorization');
				sessionStorage.removeItem('isFirstLogin');
                this.$router.push('/login');
				this.$message({
				  message: '退出成功',
				  center: true
				});
				return false;
            }else if(command == 'loginpwdchange'){
				this.pwdchangeVisible = true;
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.['pwdchangeform'].resetFields();
				})
			}
        },
		// 修改密码
		savepwdchange(formName){
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				  updatePassword(this.pwdchangeform).then(res => {
					  if(res.code == 0){
						  // 获取数据成功后的其他操作
							this.$message({
							  message: res.message,
							  type: 'success'
							});
							this.pwdchangeVisible = false;
					  }else if(res.code == 1){
						  this.$message({
						    message: res.message,
						    type: 'warning'
						  });
					  }else{
						  this.$message({
						    message: '报错啦!',
						    type: 'warning'
						  });
					  }
					   
				  });
			  } else {
				return false;
			  }
			});
		},
        // 侧边栏折叠
        collapseChage() {
            this.collapse = !this.collapse;
            bus.$emit('collapse', this.collapse);
        },
        // 全屏事件
        handleFullScreen() {
            let element = document.documentElement;
            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen();
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen();
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen();
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen();
                } else if (element.msRequestFullscreen) {
                    // IE11
                    element.msRequestFullscreen();
                }
            }
            this.fullscreen = !this.fullscreen;
        }
    },
    mounted() {
		listTaskRemindNum({}).then(res => {
			   this.$store.state.totalNum = res.data.totalNum;
			   console.log(this.$store.state.totalNum)
		});
		
		this.organinfoKind = localStorage.getItem('organizationKind');
		this.role = localStorage.getItem('role');
		
    }
};
</script>
<style scoped>

.btn-addheader{
	padding-right: 15px;
	height:70px ;
	line-height: 70px;
	color: #fff;
	text-align: center;
	letter-spacing: 1px;
}	
.btn-addheader a{
	color: #fff;
}
/* .btn-addheader	p:last-child{
	font-size: 14px;
} */
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}
.header .logo {
    float: left;
    width: 250px;
    line-height: 70px;
}
.header-right {
    float: right;
    padding-right: 50px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-left: 10px;
}
.user-avator {
    margin-left: 10px;
}
.user-avator img {
    display: block;
    /* width: 40px; */
    height: 24px;
    /* border-radius: 50%; */
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
.fzinfo-list p{
	/* line-height: 32px; */
	margin-bottom: 20px;
	letter-spacing: 1px;
	font-size: 14px;
	text-indent: 20px;
}
.fzinfo-list p span{
	display: inline-block;
	width: 120px;
	text-align: right;
	
}
.fzinfo-btn{
	display: block;
	text-align: center;
}
</style>


<style>
	.change-password .el-form-item__label::before{
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
	}
</style>